import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
// import { LoginService } from '../../login/login.service';
// import { LoginSettings } from '../../login/LoginSetting.model';
import { Report } from '../models/report.model';
import { ReportFolder } from '../models/report-folder.model';
// import { ReportParametersComponent } from '../parameters/report-parameters.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { NgForm } from '@angular/forms';
import { ReportParametersComponent } from '../parameters/report-parameters.component';
import { CheckForErrorsMessageComponent } from '../../../shared-components/guards/check-for-errors/check-for-errors-message/check-for-errors-message.component';
import { System } from '../../../shared-components/System';
// import { MyReportsComponent } from '../my-reports/my-reports.component';

@AutoUnsubscribe()
@Component({
    selector: 'reportSettingsAutoRun',
    templateUrl: './report-settings-autorun.component.html',
    styleUrls: ['./report-settings.folders.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class ReportSettingsAutoRunComponent implements OnInit, OnDestroy {

    @ViewChild('autorunForm', { read: NgForm, static: true }) autorunForm: NgForm;
    // @ViewChildren('timePickerForm', {read: NgForm}) timePickerForm: NgForm;
    thisDialogRef: MatDialogRef<ReportSettingsAutoRunComponent>;

    // loginSettings: LoginSettings;
    allowAutoRunReport: boolean;
    autoRunTime: string;
    autoRunTime24: string;
    hoursNum: Number;
    reportFolders: ReportFolder[] = [];
    // //ReportParameters: ReportParameter[]; //??

    selectedReport: Report;
    // reportSettingsDialogRef: MatDialogRef<ReportSettingsComponent>;

    reportsMode: number; // enum: MyReports = 1, AllReports = 2
    foldersChkAll: boolean;
    noFolderSelected: boolean;
    isChecked: boolean;
    inDebugMode: boolean;
    // MaximumSnapshots: number;
    maxReportSnapshotAllowed: number;
    reportParametersDialogRef: MatDialogRef<ReportParametersComponent>;
    isDirty: boolean;
    AutoRunHour_0: string;
    AutoRunMinute_0: string;
    AutoRunPeriod_0: string;
    AutoRunHour_1: string;
    AutoRunMinute_1: string;
    AutoRunPeriod_1: string;
    AutoRunHour_2: string;
    AutoRunMinute_2: string;
    AutoRunPeriod_2: string;
    today: Date;

    constructor(
        reportSettingsDialogRef: MatDialogRef<ReportSettingsAutoRunComponent>,
        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent,
        // private loginService: LoginService,
        private dialog: MatDialog,
        private reportParametersDialog: MatDialog,
        // private allReportsComponent: AllReportsComponent

    ) {

        this.thisDialogRef = reportSettingsDialogRef;
        this.selectedReport = reportService.SelectedReport;
        this.reportFolders = reportService.ReportFolders;
        // this.allowAutoRunReport = this.loginService.LoginSettings.AllowAutoRunReport;
        // this.loginSettings = loginService.LoginSettings;
        this.allowAutoRunReport = this.reportService.allowAutoRunReport;
        this.inDebugMode = reportService.inDebugMode;
        this.maxReportSnapshotAllowed = this.reportService.maxReportSnapshotAllowed;

    }

    ngOnInit() {

        // only needs called if in all reports
        if (this.reportService.isAllReports) {
            this.getMyReportFolders();
        }

        // set form auto-run time for frequency if exists
        if (this.selectedReport.AutoRunReport && this.selectedReport.AutoRunTime > '') {
            this.convertTime24to12(this.selectedReport.AutoRunTime, this.selectedReport.AutoRunFrequency);
        }

        if (this.inDebugMode) {
            console.log(this.reportFolders);
            console.log(this.reportService.ReportFolders);
        }
        this.reportService.isForSchedule = true;

        // allow auto run when this component is opened and report is in a folder
        if (this.selectedReport.ReportFolder == '') {
            this.selectedReport.AutoRunReport = false;
        } else {
            this.selectedReport.AutoRunReport = true;

        }

        this.isDirty = false;

        // default date picker to today if not set in DB (new autorun)
        if (this.selectedReport.AutoRunDate.toString() == '0001-01-01T00:00:00') {
            this.today = new Date();
            this.selectedReport.AutoRunDate = this.today;
        }


    }

    ngOnDestroy() {

        this.reportService.isForSchedule = false;
    }

    initFolder() {


        let reportIsInAllFolders = false;
        let reportIsInThisFolder = false;
        let folderCount = 0;

        for (let f = 0; f < this.reportFolders.length; f++) {
            for (let r = 0; r < this.reportFolders[f].Reports.length; r++) {
                if (this.reportFolders[f].Reports[r].Id == this.selectedReport.Id) {
                    this.reportFolders[f].ReportInFolder = true;
                    reportIsInThisFolder = true;
                    folderCount += 1;
                    break;
                }
                else {
                    this.reportFolders[f].ReportInFolder = false;
                    reportIsInThisFolder = false;
                }
            }
        }
        if (folderCount == this.reportFolders.length) {
            reportIsInAllFolders = true;
            this.foldersChkAll = true;
            this.noFolderSelected = false;
        }
        else {
            this.foldersChkAll = false;
        }
        if (folderCount == 0) {
            this.noFolderSelected = true;
        }

        if (this.inDebugMode) {
            console.log(this.reportFolders);
            console.log('foldersChkAll:');
            console.log(this.foldersChkAll);
            console.log('folderCount');
            console.log(folderCount);
        }

        if (this.reportService.inDebugMode) {
            console.log(this.selectedReport);
            console.log(this.reportFolders);

            // this.loginService.MaximumSnapshots

        }

        // this.MaximumSnapshots = this.reportService.maxReportSnapshotAllowed;

        this.setSelectedFolders();
        this.getReportParameters();
    }

    getMyReportFolders(): void {
        this.reportService.getMyReportFolders().subscribe(reportFolders => {
            this.reportFolders = reportFolders;
            this.reportService.ReportFolders = this.reportFolders;
            if (this.reportService.inDebugMode) {
                console.log('ReportSettingsAutoRunComponent=>getMyReportFolders()');
                console.log(this.reportFolders);
            }
            this.initFolder();
        });
    }

    // openAutorunDefaultParametersDialog() {
    //     this.reportParametersDialogRef = this.reportParametersDialog.open(ReportParametersComponent, {
    //         panelClass: 'tyl-mat-dialog',
    //         disableClose: true
    //     });

    //     // this.reportsDialogRef.beforeClose().subscribe(result => {
    //     //  console.log('shared/HeaderComponent =>reportsDialogRef.beforeClose()');
    //     // });


    //     this.reportParametersDialogRef.afterClosed().subscribe(result => {
    //         this.reportService.SelectedReport = null;
    //         this.reportService.autoRunSnapshot = null;
    //         this.reportService.isForSchedule = false;

    //         if (this.reportService.inDebugMode) {

    //         }
    //     });
    // }

    // openReportParametersWindow() {



    // }

    getReportParameters() {
        // todo: forschedule = true!!!
        this.reportService.getReportParameters(this.reportService.login_ID, this.selectedReport, true).subscribe(report => {
            // GetReportParameters?userId=72646&paramId=-1&ayIdentifier=1819&schoolId=10&forSchedule=true
            if (this.reportService.inDebugMode) {
                console.log(report);
            }

            this.selectedReport = report;
            this.reportService.SelectedReport = report;
            // this.openReportParametersWindow();

        });
    }

    SelectedReportToConsole() {
        console.log(this.selectedReport);
    }

    convertTime12to24(time12h: string) {

        const [time, period] = time12h.split(' ');

        let [hours, minutes] = time.split(':');

        if (hours === '12') {
            hours = '00';
        }

        if (period === 'PM') {
            this.hoursNum = parseInt(hours, 10) + 12;
            hours = this.hoursNum.toString();
        }
        // to avoid error
        minutes = minutes;

        return hours + ':' + minutes;
    }

    isValidDate(d) {
        if (Object.prototype.toString.call(d) === '[object Date]' && isFinite(d)) {
            return true;
        } else {
            return false;
        }
    }

    // isValidDate(d) {
    // if (Object.prototype.toString.call(d) === '[object Date]') {
    //     // it is a date
    //     if (isNaN(d.getTime())) {  // d.valueOf() could also work
    //       return false; // date is not valid
    //     } else {
    //       return true; // date is valid
    //     }
    //   } else {
    //     return false; // not a date
    //   }
    // }

    saveClick() { // save auto-run settings

        // if is existing autorun and user wants to delte it, no validation necessary

        if (this.selectedReport.AutoRunReport) {

            System.forceUpdateValidity(this.autorunForm);
            // this.TimePicker.validate();
            // System.forceUpdateValidity(this.TimePicker.timePickerForm);

            // if (this.reportService.inDebugMode) {
            //     console.log(this.selectedReport.AutoRunFrequency);
            //     console.log(this.selectedReport.AutoRunDate);
            //     console.log(this.AutoRunHour_2);
            //     console.log(this.AutoRunMinute_2);
            //     console.log(this.AutoRunPeriod_2);
            // }
            // set & convert time from timePicker
            // debugger;
            switch (this.selectedReport.AutoRunFrequency) {
                case 0:  // Weekly
                    if (!System.isValid(this.selectedReport.AutoRunDay) || !System.isValid(this.AutoRunHour_0) || !System.isValid(this.AutoRunMinute_0) || !System.isValid(this.AutoRunPeriod_0)) {

                        if (this.reportService.inDebugMode) {
                            console.log('System.isValid(this.selectedReport.AutoRunDay)');
                            console.log(System.isValid(this.selectedReport.AutoRunDay));
                            console.log('System.isValid(this.AutoRunHour_0)');
                            console.log(System.isValid(this.AutoRunHour_0));
                            console.log('System.isValid(this.AutoRunMinute_0)');
                            console.log(System.isValid(this.AutoRunMinute_0));
                            console.log('System.isValid(this.AutoRunHour_0)');
                            console.log(System.isValid(this.AutoRunPeriod_0));
                        }

                        return;

                    } else {

                        this.autoRunTime = this.AutoRunHour_0 + ':' + this.AutoRunMinute_0 + ' ' + this.AutoRunPeriod_0;
                    }

                    break;

                case 1: // Daily
                    if (!System.isValid(this.AutoRunHour_1) || !System.isValid(this.AutoRunMinute_1) || !System.isValid(this.AutoRunPeriod_1)) {

                        if (this.reportService.inDebugMode) {

                            console.log('System.isValid(this.AutoRunHour_1)');
                            console.log(System.isValid(this.AutoRunHour_1));
                            console.log('System.isValid(this.AutoRunMinute_1)');
                            console.log(System.isValid(this.AutoRunMinute_1));
                            console.log('System.isValid(this.AutoRunPeriod_1)');
                            console.log(System.isValid(this.AutoRunPeriod_1));
                        }

                        return;

                    } else {
                        this.autoRunTime = this.AutoRunHour_1 + ':' + this.AutoRunMinute_1 + ' ' + this.AutoRunPeriod_1;
                    }

                    break;

                case 2: // Once
                    // System.roundDateDown(this.selectedReport.AutoRunDate);
                    // if (!this.isValidDate(this.selectedReport.AutoRunDate) || !System.isValid(this.AutoRunHour_2) || !System.isValid(this.AutoRunMinute_2) || !System.isValid(this.AutoRunPeriod_2)) {
                    if (!(System.isValid(this.selectedReport.AutoRunDate) || this.isValidDate(this.selectedReport.AutoRunDate) || !System.isValid(this.AutoRunHour_2) || !System.isValid(this.AutoRunMinute_2) || !System.isValid(this.AutoRunPeriod_2))) {

                        if (this.reportService.inDebugMode) {
                            console.log('Once');
                            console.log('System.isValid(this.selectedReport.AutoRunDate)');
                            console.log(System.isValid(this.selectedReport.AutoRunDate));
                            console.log(this.selectedReport.AutoRunDate);
                            console.log('System.isValid(this.AutoRunHour_2)');
                            console.log(System.isValid(this.AutoRunHour_2));
                            console.log('System.isValid(this.AutoRunMinute_2)');
                            console.log(System.isValid(this.AutoRunMinute_2));
                            console.log('System.isValid(this.AutoRunPeriod_2)');
                            console.log(System.isValid(this.AutoRunPeriod_2));
                        }

                        return;

                    } else {

                        this.autoRunTime = this.AutoRunHour_2 + ':' + this.AutoRunMinute_2 + ' ' + this.AutoRunPeriod_2;
                    }

                    break;
            } // end switch

            // this.autoRunTime = this.TimePicker.AutoRunHour + ':' + this.TimePicker.AutoRunMinute + ' ' + this.TimePicker.AutoRunPeriod;
            this.reportService.SelectedReport.AutoRunTime = this.convertTime12to24(this.autoRunTime);

        } // end validation

        if (this.reportService.inDebugMode) {
            console.log('passed validation');
        }


        this.reportService.saveReportAutoRunSettings().subscribe(res => {
            this.thisDialogRef.close('Auto Run Saved');


        });
        // const selectedFolderIds: number[] = [];
        // for (let i = 0; i < this.reportFolders.length; i++) {
        //     if (this.reportFolders[i].ReportInFolder) {
        //         selectedFolderIds.push(this.reportFolders[i].Id);
        //     }
        // }

        // if (this.reportService.inDebugMode) {
        //     console.log('saveClick()');
        //     console.log(selectedFolderIds);
        // }

        // this.saveFolderReports(selectedFolderIds);

        // void SaveFolderReports(int loginId, int reportId, System.Collections.Generic.List<int> folderIds);

    }

    deleteClick() {

        this.selectedReport.AutoRunReport = false;
        this.reportService.saveReportAutoRunSettings().subscribe(res => {
            this.thisDialogRef.close('Auto Run Saved - delete');

        });
    }

    saveFolderReports(selectedFolderIds: number[]) {

        // first we need to save auto run settings
        this.reportService.saveReportAutoRunSettings().subscribe(res => {

            // now we need to save the report folders
            this.reportService.saveFolderReports(this.reportService.login_ID, this.selectedReport.Id, selectedFolderIds).subscribe(results => {
                this.thisDialogRef.close('Folders Saved');
            });

        });

        // this.reportService.saveFolderReports(this.reportService.login_ID, this.selectedReport.Id, selectedFolderIds).subscribe(results => {
        //     this.thisDialogRef.close('Folders Saved');
        // });

    }


    setSelectedFolders() {

        let reportIsInAllFolders = false;
        let reportIsInThisFolder = false;
        let folderCount = 0;
        for (let f = 0; f < this.reportFolders.length; f++) {
            for (let r = 0; r < this.reportFolders[f].Reports.length; r++) {
                if (this.reportFolders[f].Reports[r].Id == this.selectedReport.Id) {
                    this.reportFolders[f].ReportInFolder = true;
                    reportIsInThisFolder = true;
                    folderCount += 1;
                    break;
                }
            }
            if (!reportIsInThisFolder) {
                this.reportFolders[f].ReportInFolder = false;
            }
        }
        if (folderCount == this.reportFolders.length) {
            reportIsInAllFolders = true;
            this.foldersChkAll = true;
            this.noFolderSelected = false;
        }
        else {
            this.foldersChkAll = false;
        }
        if (folderCount == 0) {
            this.noFolderSelected = true;
        }

        if (this.reportService.inDebugMode) {
            console.log('report-setting-autorun.setSelectedFolders()');
            console.log(this.reportFolders);
            console.log('foldersChkAll:');
            console.log(this.foldersChkAll);
            console.log('folderCount');
            console.log(folderCount);
        }

    }


    cancelClick() {
        this.checkIsDirty();
        if (this.reportService.inDebugMode) {
            console.log('isDirty: ' + this.isDirty.toString());
        }

        if (this.isDirty) {

            const dialog = this.dialog.open(CheckForErrorsMessageComponent, {
                disableClose: true,
                data: {
                    errors: []
                }
            });

            dialog.componentInstance.dialogBox = dialog;
            dialog.afterClosed().subscribe(result => {
                console.log(result);
                switch (result) {
                    case 1: { // determine if edit or new folder > save and continue
                        this.saveClick();
                        break;
                    }
                    case 0: { // continue without save
                        this.thisDialogRef.close(false);
                        break;
                    }
                    case -1: { // cancel
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });

        }
        else { // no unsaved changes
            this.thisDialogRef.close();   // true to refreshFolders
        }

    }

    autoRunReportClick() {
    }


    checkAllFolders(foldersChkAll: boolean) {

        this.foldersChkAll = foldersChkAll; // this.isChecked;
        this.noFolderSelected = !foldersChkAll; // this.isChecked;

        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => checkAllFolders( ' + foldersChkAll + ')');
            console.log(this.reportFolders);
            console.log(this.foldersChkAll);
            console.log(this.noFolderSelected);
        }


        for (let i = 0; i < this.reportFolders.length; i++) {
            if (this.foldersChkAll) {
                this.reportFolders[i].ReportInFolder = true;
            }

            else {
                this.reportFolders[i].ReportInFolder = false;
            }

        }
        if (this.noFolderSelected == true) {
            this.selectedReport.AutoRunReport = false;
        }

        // if (this.reportService.inDebugMode) {
        //     console.log('ReportSettingsComponent => checkAllFolders( ' + foldersChkAll + ')');
        //     console.log(this.reportFolders);
        // }

    }

    chkFolder(folder: ReportFolder) {

        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => chkFolder( ' + folder + ')');
            console.log(this.reportFolders);
        }

        // this.setSelectedFolders();

        // this.noFolderSelected = true;
        let reportInFolderCount = 0;

        for (let x = 0; x < this.reportFolders.length; x++) {
            if (this.reportFolders[x].ReportInFolder == true) {
                reportInFolderCount += 1;
            }
        }


        if (reportInFolderCount < this.reportFolders.length) {
            this.foldersChkAll = false;
            return;
        }

        if (reportInFolderCount == this.reportFolders.length) {
            this.checkAllFolders(true);
            return;
        }

        if (reportInFolderCount == 0) {
            this.selectedReport.AutoRunReport = false;
            this.checkAllFolders(false);
            this.noFolderSelected = true;
            return;
        }

        // this.reportService.ReportFolders = this.reportFolders; // ??


        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => chkFolder( ' + folder + ')');
        }

    }

    setFrequency(frequency) {

        // this.selectedReport.AutoRunFrequency = frequency;
        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => setFrequency( ' + frequency + ')');
        }
        this.selectedReport.AutoRunFrequency = frequency;
        // this.reportService.SelectedReport.AutoRunFrequency = frequency;
        // this.TimePicker.selectedReport.AutoRunFrequency = frequency;
    }

    convertTime24to12(time24h: string, frequency: number) {
        let period = 'AM';
        let [hours, minutes] = time24h.split(':');

        if (hours > '12') {
            this.hoursNum = parseInt(hours, 10) - 12;
            hours = this.hoursNum.toString();
            period = 'PM';
        }

        // need to account for 12 since it was defaulting to AM

        if (hours == '12') {
            period = 'PM';
        }

        if (hours.length == 1) {
            hours = '0' + hours;
        }

        // to avoid error
        minutes = minutes;

        switch (frequency) {
            case 0:
                if (hours.length == 1) {
                    this.AutoRunHour_0 = '0' + hours;

                } else { this.AutoRunHour_0 = hours; }
                this.AutoRunMinute_0 = minutes;
                this.AutoRunPeriod_0 = period;
                break;
            case 1:
                if (hours.length == 1) {
                    this.AutoRunHour_1 = '0' + hours;

                } else { this.AutoRunHour_1 = hours; }
                this.AutoRunMinute_1 = minutes;
                this.AutoRunPeriod_1 = period;
                break;
            case 2:
                if (hours.length == 1) {
                    this.AutoRunHour_2 = '0' + hours;

                } else { this.AutoRunHour_2 = hours; }
                this.AutoRunMinute_2 = minutes;
                this.AutoRunPeriod_2 = period;
                break;
        } // end switch


        // return hours + ':' + minutes + period;
    }

    checkIsDirty() {
        // compare control values against whats in report service
        // convert time in forms


        // check if user changed frequency
        if (this.selectedReport.AutoRunFrequency != this.reportService.SelectedReport.AutoRunFrequency) {

            this.isDirty = true;
        }

        switch (this.selectedReport.AutoRunFrequency) {
            case 0:
                this.autoRunTime = this.AutoRunHour_0 + ':' + this.AutoRunMinute_0 + ' ' + this.AutoRunPeriod_0;
                this.autoRunTime24 = this.convertTime12to24(this.autoRunTime);

                if (this.selectedReport.AutoRunDay != this.reportService.SelectedReport.AutoRunDay ||
                    this.autoRunTime24 != this.reportService.SelectedReport.AutoRunTime) {

                    this.isDirty = true;
                }
                break;

            case 1:
                this.autoRunTime = this.AutoRunHour_1 + ':' + this.AutoRunMinute_1 + ' ' + this.AutoRunPeriod_1;
                this.autoRunTime24 = this.convertTime12to24(this.autoRunTime);

                if (this.autoRunTime24 != this.reportService.SelectedReport.AutoRunTime) {

                    this.isDirty = true;
                }
                break;
            case 2:
                this.autoRunTime = this.AutoRunHour_2 + ':' + this.AutoRunMinute_2 + ' ' + this.AutoRunPeriod_2;
                this.autoRunTime24 = this.convertTime12to24(this.autoRunTime);

                if (this.selectedReport.AutoRunDate != this.reportService.SelectedReport.AutoRunDate ||
                    this.autoRunTime24 != this.reportService.SelectedReport.AutoRunTime) {

                    this.isDirty = true;
                }
                break;
        } // end switch

        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => checkIsDirty()');
            console.log(this.selectedReport.AutoRunFrequency);
            console.log(this.selectedReport.AutoRunDate);
            console.log(this.selectedReport.AutoRunDay);
            console.log(this.autoRunTime24);
            console.log('checkIsDirty() > report service');

            console.log(this.reportService.SelectedReport.AutoRunFrequency);
            console.log(this.reportService.SelectedReport.AutoRunDate);
            console.log(this.reportService.SelectedReport.AutoRunDay);
        }



    }



    // open(){
    //     // this.open = function ($event, index) {
    //     // $event.preventDefault();
    //     // $event.stopPropagation();
    //     // this.opened.forEach(function (item, index) { this.opened[index] = false; });
    //     // this.opened[index] = true;

    //     if (this.reportService.inDebugMode) {
    //         console.log('ReportSettingsComponent => open( ' + '' + ')');
    //     }
    // }


} // end class

